import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';
import { EUserStatuses } from '@modules/transactions/types';
import { TTransaction } from '@modules/transactions/types2';

import ClockIcon from './clock.svg';
import OverflowCell from '../OverflowCell';

import style from './Time.scss';

const cn = bemCssModules(style, 'Time');
const ti = getTestId('Time');

const getTime = (lang: string | undefined, timestamp: number) =>
  new Date(timestamp).toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' });

export type TTime = {
  timestamp: number;
  type: TTransaction['type'];
  isFailed?: boolean;
  status: EUserStatuses;
};

const Time: CustomFC<TTime> = ({ className, timestamp, type, isFailed, status }) => {
  const { t } = useTranslation();

  const [{ global }] = useStore();
  const { lang } = global;

  const fallbackType = type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, ' ');
  const isPending = status === EUserStatuses.pending;

  return (
    <OverflowCell className={cn({ isFailed }, [className])} column={1} error={isFailed}>
      {getTime(lang, timestamp)}
      <span className={cn('title', { isPending })}>
        {' · '}
        {isFailed ? (
          <span data-testid={ti('transaction-status')}>{t(`transactions.${status}`)}</span>
        ) : (
          <span data-testid={ti('transaction-type')}>
            {t(`transactions.${type}`, fallbackType)}
          </span>
        )}
      </span>
      {isPending && (
        <>
          {' · '}
          <div className={cn('pending')} data-testid={ti('transaction-status')}>
            <span>{t(`transactions.${status}`)}</span>
            <ClockIcon />
          </div>
        </>
      )}
    </OverflowCell>
  );
};

export default Time;
